import { createRef } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'
import { Routes } from 'common/constants'
import { logBridgeError, sendSelectContent } from 'common/helpers'
import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { useHasScroll } from 'common/hooks/useHasScroll'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'

// import { useSupportResponse } from '../repository/ServiceResponse.repository'

export function useServiceResponse() {
  const { state } = useLocation()

  const { response, aditionalInfo } = state

  const ref = createRef<HTMLDivElement>()

  const hasScroll = useHasScroll(ref)

  const navigate = useNavigate()

  const { privacyCenterContent, userSelectedEntity } = useAppContext()

  const content = privacyCenterContent?.components?.supportResponse?.content
  const isActive = !!privacyCenterContent?.components?.supportResponse?.isActive

  const isResponseError = (!response || response === '') && (!aditionalInfo || aditionalInfo === '')

  useScreenFinishLoadTac({
    name: 'ServiceResponse',
    screen: Routes.SERVICE_RESPONSE,
    action: 'ServiceResponseFinishLoad',
    entity: userSelectedEntity,
    shouldSend: isActive && !isResponseError,
    logLabel: 'send service response finish tac',
  })

  return {
    ...content,
    response,
    aditionalInfo,
    isResponseError,
    hasScroll,
    isActive,
    ref,
    onClick: async () => {
      try {
        await sendSelectContent({
          flow: 'service_response',
          step: 'service_response',
          screen_name: Routes.SERVICE_RESPONSE,
          element_name: 'understoodReturnToList',
          element_type: 'button',
          parent_name: 'ServiceResponse',
          scenario: JSON.stringify({
            screen: Routes.SERVICE_RESPONSE,
            product: userSelectedEntity,
            ref_type: 'button',
            content_action: 'touch',
          }),
        })
      } catch (error: unknown) {
        logBridgeError('send service response understood tic', error)
      }

      navigate(Routes.MY_SERVICE_REQUESTS)
    },
    onError: () => {
      navigate(Routes.ERROR)
    },
  }
}
